import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CheckboxSlider } from 'ui-components/components/checkbox-slider';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import style from './style.module.less';

/**
 * @typedef {import('../../../../../../../prop-types/intl-types').MessageDescriptor} MessageDescriptor
 */

/**
 * @typedef {object} PackingSlipSettingProps
 * @property {MessageDescriptor} title - Message descriptor for the setting title/header
 * @property {MessageDescriptor} [description] - Message descriptor for the setting description
 * @property {boolean} [isChecked=false] - Whether the setting checkbox is checked
 * @property {() => void} onChange - Callback function triggered when the checkbox is toggled
 * @property {boolean} [disabled=false] - Whether the setting is disabled/locked
 * @property {string} [name] - Name attribute for the checkbox input, used for form identification
 * @property {MessageDescriptor} [tooltipMessage] - Message descriptor for the tooltip shown when setting is disabled
 */

/**
 * A component that renders a packing slip configuration setting with proper centering for warehouse packing page
 * @param {PackingSlipSettingProps} props - Component props
 * @returns {JSX.Element} Packing slip setting component
 */
export const PackingSlipSetting = ({ title, description, isChecked = false, onChange, disabled = false, tooltipMessage, name }) => {
  return (
    <div className={style['setting-container']}>
      <FlexColumn className={style['setting-text']}>
        <Text textType={TextType.Paragraph} value={title} />
        {description ? <Text textType={TextType.Caption} value={description} /> : null}
      </FlexColumn>
      <CheckboxSlider
        checkboxId={name}
        checked={isChecked}
        disabled={disabled}
        disabledTooltipMessage={tooltipMessage ? <FormattedMessage {...tooltipMessage} /> : null}
        onChange={onChange}
      />
    </div>
  );
};
